// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  min-width: 400px;
}

.pilot-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  z-index: 4;
  min-height: 50px;
}

.background-striped {
  background: #f4f5f7;
}

.display-3 span {
  font-size: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/landing/landing.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["main {\r\n    min-width: 400px;\r\n}\r\n\r\n.pilot-warning{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 16px;\r\n    z-index: 4;\r\n    min-height: 50px;\r\n }\r\n\r\n.background-striped {\r\n    background: #f4f5f7;\r\n}\r\n\r\n.display-3 span {\r\n    font-size: 1.8rem;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
